import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { useTheme } from 'styled-components';
import { digitFormater } from '../../../../service/functions';
import { sliceValue } from '../../../../service/seasonTransfers';
import {
  StyledChartCenter,
  StyledChartWrap,
  StyledCenterLabel,
  StyledCenterValue,
  StyledTooltip,
  StyledTooltipMeta,
  StyledTooltipName,
} from './styled';

const DonutTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const row = payload[0].payload;
  return (
    <StyledTooltip>
      <StyledTooltipName>{row.playerName}</StyledTooltipName>
      <StyledTooltipMeta>
        {row.fromName} → {row.toName}
      </StyledTooltipMeta>
      <StyledTooltipMeta>{row.feeLabel}</StyledTooltipMeta>
    </StyledTooltip>
  );
};

const TransferDonut = ({ rows, activeId, onSelect }) => {
  const theme = useTheme();
  const total = rows.reduce((sum, row) => sum + (row.fee || 0), 0);
  const data = rows.map((row) => ({
    ...row,
    value: sliceValue(row, rows),
  }));

  return (
    <StyledChartWrap>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          {data.length > 0 ? (
            <Pie
              data={data}
              dataKey="value"
              nameKey="playerName"
              cx="50%"
              cy="50%"
              innerRadius={68}
              outerRadius={92}
              paddingAngle={data.length > 1 ? 1.5 : 0}
              startAngle={90}
              endAngle={-270}
              stroke="none"
              onClick={(entry) => {
                const row = entry?.payload || entry;
                if (row?.id) onSelect(row);
              }}
              cursor="pointer"
            >
              {data.map((row) => (
                <Cell
                  key={row.id}
                  fill={row.color}
                  opacity={
                    activeId &&
                    data.some((item) => item.id === activeId) &&
                    activeId !== row.id
                      ? 0.45
                      : 1
                  }
                />
              ))}
            </Pie>
          ) : (
            <Pie
              data={[{ value: 1 }]}
              dataKey="value"
              cx="50%"
              cy="50%"
              innerRadius={68}
              outerRadius={92}
              startAngle={90}
              endAngle={-270}
              stroke="none"
            >
              <Cell fill={theme.borderSubtle} />
            </Pie>
          )}
          <Tooltip content={data.length ? <DonutTooltip /> : () => null} />
        </PieChart>
      </ResponsiveContainer>
      <StyledChartCenter>
        <StyledCenterValue>
          {data.length ? `$${digitFormater(total, true)}` : '—'}
        </StyledCenterValue>
        <StyledCenterLabel>
          {data.length === 1 ? '1 transfer' : `${data.length} transfers`}
        </StyledCenterLabel>
      </StyledChartCenter>
    </StyledChartWrap>
  );
};

export default TransferDonut;
